"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dispatchTrackingEvent;
function dispatchTrackingEvent(data) {
  (window.dataLayer = window.dataLayer || []).push(data);
}


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/~/react-tracking/build/dispatchTrackingEvent.js
// module id = 939
// module chunks = 48 49 50